import { useEffect } from "react";
import { useSelector } from "react-redux";

import { useCustomerServiceApi } from "@/api/hooks/customerService.hook";
import { BonusCardBalanceResponse } from "@/api/hooks/customerService.types";
import { DefaultFor } from "@/api/mappers/default.mapper";
import BonusCardBalance from "@/components/Account/BonusCardBalance/bonusCardBalance.component";
import { useThunkDispatch } from "@/redux/dispatcher";
import * as CustomerModule from "@/redux/modules/api/data/customer/customer.module";
import { getCustomer } from "@/redux/modules/api/data/customer/customer.selectors";

type Props = {
    innerHTML: string;
};

const BonusCardBalanceContainer = ({ innerHTML }: Props) => {
    const dispatch = useThunkDispatch();
    const customer = useSelector(getCustomer);

    const bonusCardnumber =
        customer?.eBonusCardNumber || customer?.bonusCardNumber;

    const [{ data, loading }, getBalance] = useCustomerServiceApi(
        {
            url: "/bonuscards/:bonusCardnumber",
            method: "GET",
            mapper: DefaultFor<BonusCardBalanceResponse>()
        },
        { manual: true, useCache: false }
    );

    useEffect(() => {
        dispatch(CustomerModule.load);
    }, [dispatch]);

    // biome-ignore lint/correctness/useExhaustiveDependencies: <TODO>
    useEffect(() => {
        if (!bonusCardnumber) return;

        getBalance({
            urlParams: {
                bonusCardnumber: bonusCardnumber
            }
        });
    }, [bonusCardnumber]);

    return (
        <BonusCardBalance
            innerHTML={innerHTML}
            bonusCardBalance={data?.balance || null}
            bonusCardNumber={bonusCardnumber || null}
            isLoading={loading}
        />
    );
};

export { BonusCardBalanceContainer };
